import merge from 'lodash/merge';
import { baseTheme, updateTheme } from './index';
import { flattenTheme } from './utils';
import { withOpacity } from '../helpers';
var kioskBaseTheme = merge({}, baseTheme, {
  main: {
    fontSizes: {
      lg: "34px",
      md: "28px"
    },
    colours: {
      secondary: {
        d1: '#36AEED'
      },
      tertiary: {
        l1: '#010101',
        l4: '#959595',
        l5: '#E0E0E0',
        l6: '#CECECE',
        d1: '#B4B4B4'
      }
    }
  }
});
export var getKioskTheme = function getKioskTheme(newTheme) {
  var flatTheme = flattenTheme(updateTheme(kioskBaseTheme, newTheme));
  var componentsTheme = {
    button: {
      minWidth: '180px',
      minHeight: 'auto',
      border: '2px solid transparent',
      borderRadius: flatTheme.rad_xl,
      padding: "".concat(flatTheme.space_3, "px ").concat(flatTheme.space_6, "px"),
      fontSize: flatTheme.fs_md,
      background: flatTheme.cl_pri_base,
      secondary: {
        background: flatTheme.cl_white,
        borderColor: "".concat(flatTheme.cl_pri_base),
        color: flatTheme.cl_pri_base,
        hoverBg: flatTheme.cl_pri_base,
        hoverColor: flatTheme.cl_white
      },
      link: {
        color: flatTheme.cl_sec_d1,
        fontFamily: flatTheme.ff_sec_thin
      },
      outline: {},
      large: {
        fontSize: flatTheme.fs_lg,
        minHeight: '120px',
        minWidth: '128px',
        borderWidth: '3px',
        padding: "".concat(flatTheme.space_2, "px ").concat(flatTheme.space_6, "px")
      },
      disabled: {
        background: flatTheme.cl_ter_l5,
        color: flatTheme.cl_ter_d1,
        borderColor: flatTheme.cl_ter_l5
      },
      customStyle: {}
    },
    tab: {
      bottomBorderColor: flatTheme.cl_ter_l6,
      tabBarDividerPositionBottom: 0,
      tabItemContainerPadding: "0 0 6px 0",
      selectedTabTitleColor: flatTheme.cl_white,
      tabTitleColor: withOpacity(flatTheme.cl_white, 0.4),
      tabItemContainerHoverBg: 'transparent',
      tabItemContainerActiveBg: 'transparent',
      tabItemContainerBg: 'transparent',
      tabItemIndicatorBgColor: flatTheme.cl_white,
      tabBarDividerBgColor: flatTheme.cl_ter_l6,
      fontSize: '32px',
      textTransform: 'uppercase',
      tabItemMinWidth: '225px',
      hideScrollArrow: true,
      tabContainerWidth: 'auto',
      secondary: {
        tabTitleColor: withOpacity(flatTheme.cl_ter_l1, 0.4),
        selectedTabTitleColor: flatTheme.cl_black,
        tabItemContainerActiveBg: 'transparent',
        tabItemContainerBg: 'transparent',
        afterTriangleColor: flatTheme.cl_white,
        tabItemIndicatorBgColor: flatTheme.cl_black,
        bottomBorderColor: flatTheme.cl_ter_l6,
        tabItemContainerHoverBg: 'transparent',
        tabBarDividerBgColor: flatTheme.cl_ter_l6
      }
    },
    text: {
      fontFamilyType: 'secondary',
      bannerTitle: {
        fontWeight: 'bold',
        fontSize: [42, 42, 84, 84, 84]
      },
      pageTitle: {
        fontWeight: 'bold',
        fontSize: [42, 42, 84, 84, 84]
      },
      sectionTitle: {
        fontWeight: 'bold',
        fontSize: [32, 32, 42, 42, 42]
      },
      sectionTitle02: {
        fontWeight: 'bold',
        fontSize: [32, 32, 42, 42, 42]
      },
      header: {
        fontSize: [28, 28, 32, 32, 32]
      },
      boldBody: {
        fontSize: [24, 24, 28, 28, 28]
      },
      body: {
        fontSize: [24, 24, 28, 28, 28],
        lineHeight: 1.5
      },
      smallBody: {
        fontSize: [18, 18, 24, 24, 24]
      }
    },
    modal: {
      titlePadding: "0 0 ".concat(flatTheme.space_4, " 0"),
      padding: '54px 54px 54px 54px',
      iconColor: flatTheme.cl_black,
      maxWide: 9
    },
    selector: {
      border: "1px solid ".concat(flatTheme.cl_ter_l4),
      selectedBorder: "3px solid ".concat(flatTheme.cl_sec_d1),
      borderRadius: '16px',
      padding: '32px 36px 32px 36px',
      boxShadow: 'none',
      disabledOpacity: 1,
      disabledColor: flatTheme.cl_ter_l4
    }
  };
  return Object.assign({}, flatTheme, componentsTheme);
};
export var kioskTheme = getKioskTheme();
export default kioskTheme;